module.exports = __webpack_public_path__ + "bc867410478d84ce606c21fb58f161f6.svg";